<template>
  <div class="ggtf-modal-overlay" :class="{ show: show }">
    <div class="ggtf-modal-content" @click.stop>
      <div class="ggtf-modal-header">
        <h3>{{ $t('_ggtg._hzje') }}</h3>
        <button class="ggtf-close-btn" @click="show = false">
          <CloseCircleOutlined style="font-size: 22px" />
        </button>
      </div>
      <div class="ggtf-modal-body">
        <div class="ggtf-detail-cover">
          <img :src="current.img" :alt="current.title" class="ggtf-detail-image" />
        </div>
        <div class="ggtf-detail-info">
          <h4 class="ggtf-detail-title">{{ current.title }}</h4>
          <div class="ggtf-detail-code">{{ $t('_ggtf._hdbm') }}: {{ current.code }}</div>

          <div class="ggtf-detail-section">
            <h5>{{ $t('_ggtf._hdjs') }}</h5>
            <p class="ggtf-detail-desc">{{ current.content }}</p>
          </div>

          <div class="ggtf-detail-section">
            <!-- <h5>{{ $t('_ggtg._dqye') }}</h5> -->
            <div class="ggtf-requirements">
              <div class="ggtf-requirement">
                <img src="../../static/img/coins.png" style="width: 20px; height: 20px" />
                <div class="ndje22">${{ wallet.balance }}</div>
                <router-link :to="{ name: 'deposit' }">{{ $t('_ggtg._qcz') }}>></router-link>
              </div>
              <div class="ggtf-requirement">
                <div class="shtr1">{{ $t('_ggtg._hzje') }}:</div>
                <div>${{ current.zr_store_income }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="ggtf-modal-footer">
        <button class="ggtf-cancel-btn" @click="show = false">{{ $t('_ggtf._qx') }}</button>
        <button class="ggtf-confirm-btn" @click="onSubmit()">{{ $t('_ggtg._ljhz') }}</button>
      </div>
    </div>

    <!-- 密码输入框 -->
    <toast-password ref="pay" @sumbit="onPwdSubmit" :okText="$t('_ggtg._ljhz')"></toast-password>
  </div>
</template>

<script>
import { CloseCircleOutlined } from '@ant-design/icons-vue'
import ToastPassword from './ToastPassword.vue'
export default {
  name: 'AdvBuyVue',
  components: { ToastPassword, CloseCircleOutlined },
  data() {
    return {
      show: false,
      current: {},
      wallet: {}
    }
  },
  methods: {
    open(item) {
      this.show = true
      this.current = item
      this.getWallet()
    },
    getWallet() {
      let that = this
      this.$api.userWallet.getWallet().then((res) => {
        that.wallet = res.data
      })
    },
    //立即购买
    onSubmit() {
      if (this.wallet.balance < this.current.zr_store_income) {
        this.$message.warning(this.$t('_ggtg._yebz'))
        return
      }
      this.$refs.pay.open()
    },
    onPwdSubmit(passwd) {
      this.$message.loading({ content: this.$t('_ggtf._zfz'), key: 'msg' })
      let that = this
      this.$api.videoAdv
        .payAdvIncome({
          code: this.current.zr_code,
          passwd: passwd
        })
        .then((res) => {
          if (res.code == 1) {
            that.$message.warning({ content: res.msg, key: 'msg' })
            return
          }
          that.$refs.pay.close()
          that.show = false
          that.$message.success({ content: res.msg, key: 'msg' })

          //重置
          that.$emit('success')
        })
        .catch(() => {
          //   hide()
        })
    }
  }
}
</script>

<style>
.ndje22 {
  color: #ff9800;
  font-size: 16px;
}

.shtr1 {
  font-size: 16px;
  font-weight: bold;
}
</style>
